import React from 'react';
import classNames from 'classnames';

import { FormattedMessage } from '../../../util/reactIntl';

import css from './MainPanelHeader.module.css';
import TopbarSearchForm from '../../TopbarContainer/Topbar/TopbarSearchForm/TopbarSearchForm';
import { useConfiguration } from '../../../context/configurationContext';
import { isMainSearchTypeKeywords, isOriginInUse } from '../../../util/search';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { useRouteConfiguration } from '../../../context/routeConfigurationContext';
import { getSearchPageResourceLocatorStringParams } from '../SearchPage.shared';
import { createResourceLocatorString } from '../../../util/routes';
import { useLocation } from 'react-router-dom/cjs/react-router-dom';

/**
 * MainPanelHeader component
 *
 * @component
 * @param {Object} props
 * @param {string} [props.className] - Custom class that extends the default class for the root element
 * @param {string} [props.rootClassName] - Custom class that overrides the default class for the root element
 * @param {React.Node} props.children - The children
 * @param {React.Node} props.sortByComponent - The sort by component
 * @param {boolean} props.isSortByActive - Whether the sort by is active
 * @param {boolean} props.listingsAreLoaded - Whether the listings are loaded
 * @param {number} props.resultsCount - The results count
 * @param {boolean} props.searchInProgress - Whether the search is in progress
 * @param {React.Node} props.noResultsInfo - The no results info
 * @returns {JSX.Element}
 */
const MainPanelHeader = props => {
  const {
    rootClassName,
    className,
    children,
    sortByComponent,
    isSortByActive,
    listingsAreLoaded,
    resultsCount,
    searchInProgress = false,
    noResultsInfo,
  } = props;

  const classes = classNames(rootClassName || css.root, className);
  const config = useConfiguration();
  const history = useHistory();
  const routeConfiguration = useRouteConfiguration();
  const location = useLocation();
  const currentSearchParams = Object.fromEntries(new URLSearchParams(location.search));
  const handleSubmit = values => {
    if (!values?.keywords) return null;
    const topbarSearchParams = () => {
      if (isMainSearchTypeKeywords(config)) {
        return { keywords: values?.keywords };
      }
      // topbar search defaults to 'location' search
      const { search, selectedPlace } = values?.location;
      const { origin, bounds } = selectedPlace;
      const originMaybe = isOriginInUse(config) ? { origin } : {};

      return {
        ...originMaybe,
        address: search,
        bounds,
      };
    };
    const searchParams = {
      ...currentSearchParams,
      ...topbarSearchParams(),
    };

    const { routeName, pathParams } = getSearchPageResourceLocatorStringParams(
      routeConfiguration,
      location
    );

    history.push(
      createResourceLocatorString(routeName, routeConfiguration, pathParams, searchParams)
    );
  };
  return (
    <div className={classes}>
      <div className={css.searchOptions}>
        <TopbarSearchForm
          className={css.searchLink}
          desktopInputRoot={css.topbarSearchWithLeftPadding}
          onSubmit={handleSubmit}
          initialValues={{}}
          appConfig={config}
        />
        {isSortByActive ? <div className={css.sortyByWrapper}>{sortByComponent}</div> : null}{' '}
      </div>
      <div className={css.searchResultSummary}>
        <span className={css.resultsFound}>
          {searchInProgress ? (
            <FormattedMessage id="MainPanelHeader.loadingResults" />
          ) : (
            <FormattedMessage id="MainPanelHeader.foundResults" values={{ count: resultsCount }} />
          )}
        </span>
      </div>

      {children}
    </div>
  );
};

export default MainPanelHeader;
